module.exports = __webpack_public_path__ + "img/img013.1aec6517.png";